import Vue from 'vue';
import Framework7 from './framework7-custom.js';
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';
// import { loadLanguageAsync } from './i18n.js';

import '../css/framework7-custom.less';
import '../css/icons.css';
import '../css/app.less';
import 'video.js/dist/video-js.min.css';

import App from '../components/App.vue';
import store from '../store/index.js';
import i18n from '../js/i18n.js';
import VuePlyr from 'vue-plyr';
import VueMeta from 'vue-meta';
// import videojs from 'video.js';
// import 'videojs-youtube/dist/Youtube.js';

// window.videojs = videojs;

Framework7.use(Framework7Vue);

Vue.use(VuePlyr, {
  plyr: {
    tooltips: {
      controls: true,
    },
    captions: {
      active: true,
    },
  },
});

Vue.use(VueMeta);

export default new Vue({
  el: '#app',
  components: {
    app: App,
  },
  render: (h) => h(App),
  store,
  i18n,
});
